/* cuWomenRefresh: visual treatment for the genuine women UV Releasit form.
 * No opening, selection, pricing, consent, validation or submission ownership. */
(() => {
  'use strict';
  const HANDLE = 'buzo-para-mujer-con-capucha-y-mascara-integrada';
  const ROOT = '[data-cu-women-refresh][data-cuw-product-id="15430370623795"]';
  const MODALS = '#_rsi-cod-form-modal, #rsi_form_wrapper';
  if (window.cuWomenRefresh || !document.querySelector(ROOT)) return;
  const active = () => location.pathname.replace(/\/$/, '').endsWith('/products/' + HANDLE) && document.querySelector(ROOT);
  const styles = new Map();
  let queued = false;
  const addClass = (node, name) => { if (node && !node.classList.contains(name)) node.classList.add(name); };
  function ownStyle(node, property, value) {
    if (!node) return;
    let entries = styles.get(node);
    if (!entries) { entries = new Map(); styles.set(node, entries); }
    let entry = entries.get(property);
    if (!entry) {
      entry = { before: node.style.getPropertyValue(property), priority: node.style.getPropertyPriority(property), after: null };
      entries.set(property, entry);
    }
    if (node.style.getPropertyValue(property) === entry.after && node.style.getPropertyPriority(property) === 'important') return;
    node.style.setProperty(property, value, 'important');
    entry.after = node.style.getPropertyValue(property);
  }
  function fieldIcon(name) {
    const paths = {
      first_name: '<circle cx="12" cy="8" r="4"/><path d="M4 21v-2a8 8 0 0 1 16 0v2"/>',
      last_name: '<circle cx="12" cy="8" r="4"/><path d="M4 21v-2a8 8 0 0 1 16 0v2"/>',
      phone: '<path d="m7 3 3 5-2 2a17 17 0 0 0 6 6l2-2 5 3-1 4c-9 1-18-8-17-17z"/>',
      province_country_field: '<path d="M19 10c0 5-7 11-7 11S5 15 5 10a7 7 0 1 1 14 0Z"/><circle cx="12" cy="10" r="2"/>',
      city: '<path d="M19 10c0 5-7 11-7 11S5 15 5 10a7 7 0 1 1 14 0Z"/><circle cx="12" cy="10" r="2"/>',
      address: '<path d="m3 11 9-8 9 8M5 10v11h14V10M10 21v-7h4v7"/>'
    };
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + (paths[name] || '<path d="M5 3h14v18H5zM8 8h8M8 12h8M8 16h5"/>') + '</svg>';
  }
  function legacyFields(modal) {
    if (modal.id !== '_rsi-cod-form-modal') return;
    modal.querySelectorAll('._rsi-modal-fields-item').forEach(wrapper => {
      const input = Array.from(wrapper.children).find(node => node.matches('input:not([type="hidden"]):not([type="checkbox"]):not([type="radio"]),select,textarea'));
      if (!input || !input.name || input.closest('._rsi-quantity-offers-variants')) return;
      addClass(wrapper, 'cuWomenRefresh-field');
      if (wrapper.querySelector('[data-cu-women-refresh-icon]')) return;
      const icon = document.createElement('span');
      icon.dataset.cuWomenRefreshIcon = '';
      icon.className = 'cuWomenRefresh-field__icon';
      icon.setAttribute('aria-hidden', 'true');
      icon.innerHTML = fieldIcon(input.name);
      wrapper.appendChild(icon);
    });
  }
  function nativeHeads(modal) {
    if (modal.id === '_rsi-cod-form-modal') return;
    modal.querySelectorAll('label.rsi-quantity-product').forEach(offer => {
      const image = offer.querySelector('.rsi-quantity-image-wrapper');
      const title = offer.querySelector('.rsi-quantity-title-wrapper');
      const price = offer.querySelector('.rsi-quantity-price-container');
      const info = title && price && title.parentElement?.parentElement;
      if (!image || !title || !price || !info || !info.contains(price) || info.contains(image) || image.parentElement !== info.parentElement) return;
      addClass(image.parentElement, 'cuWomenRefresh-offer-head');
      addClass(info, 'cuWomenRefresh-offer-info');
      addClass(title.parentElement, 'cuWomenRefresh-offer-title-row');
    });
  }
  function submitAppearance(modal) {
    const button = modal.querySelector('button._rsi-modal-submit-button[type="submit"],button.rsi-submit_button[type="submit"]');
    if (!button) return;
    ownStyle(button, 'background', '#7d1430');
    ownStyle(button, 'color', '#ffffff');
    ownStyle(button, 'border', '2px solid #cfac75');
    ownStyle(button, 'border-radius', '25px');
    ownStyle(button, 'box-shadow', '0 3px 8px #7d14302b');
    const content = button.querySelector('.rsi-custom-button-content') || button;
    const loading = button.querySelector('._rsi-modal-loading-icon,.rsi-loading-icon') || button.disabled || button.getAttribute('aria-busy') === 'true';
    const nativeLabel = Array.from(content.childNodes).some(node => !(node.nodeType === 1 && node.hasAttribute('data-cu-women-refresh-note')) && node.textContent.trim());
    if (loading || !nativeLabel) { content.querySelector('[data-cu-women-refresh-note]')?.remove(); return; }
    if (content !== button) addClass(content, 'cuWomenRefresh-submit-content');
    if (!content.querySelector('[data-cu-women-refresh-note]')) {
      const note = document.createElement('span');
      note.dataset.cuWomenRefreshNote = '';
      note.className = 'cuWomenRefresh-submit-note';
      note.textContent = 'PAGO CONTRA ENTREGA';
      content.appendChild(note);
    }
  }
  function cleanup() {
    observer.disconnect();
    document.querySelectorAll('[data-cu-women-refresh-icon],[data-cu-women-refresh-note]').forEach(node => node.remove());
    document.querySelectorAll('.cuWomenRefresh-cod,.cuWomenRefresh-field,.cuWomenRefresh-offer-head,.cuWomenRefresh-offer-info,.cuWomenRefresh-offer-title-row,.cuWomenRefresh-submit-content').forEach(node => node.classList.remove('cuWomenRefresh-cod','cuWomenRefresh-field','cuWomenRefresh-offer-head','cuWomenRefresh-offer-info','cuWomenRefresh-offer-title-row','cuWomenRefresh-submit-content'));
    styles.forEach((entries, node) => entries.forEach((entry, property) => {
      if (node.style.getPropertyValue(property) !== entry.after) return;
      if (entry.before) node.style.setProperty(property, entry.before, entry.priority);
      else node.style.removeProperty(property);
    }));
    styles.clear();
  }
  function paint() {
    queued = false;
    if (!active()) { cleanup(); return; }
    document.querySelectorAll(MODALS).forEach(modal => {
      if (!modal.classList.contains('cuw-native-cod')) {
        if (modal.classList.contains('cuWomenRefresh-cod')) modal.classList.remove('cuWomenRefresh-cod');
        return;
      }
      addClass(modal, 'cuWomenRefresh-cod');
      legacyFields(modal);
      nativeHeads(modal);
      const heading = modal.querySelector('._rsi-modal-header-title,.rsi-form-title-container');
      ownStyle(heading, 'text-align', 'left');
      ownStyle(heading, 'font', '700 17px/25px CuwPoppins,Arial,sans-serif');
      submitAppearance(modal);
    });
  }
  function schedule() { if (!queued) { queued = true; requestAnimationFrame(paint); } }
  const observer = new MutationObserver(schedule);
  observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'open', 'style', 'disabled', 'aria-busy'] });
  window.cuWomenRefresh = Object.freeze({ refresh: schedule });
  schedule();
})();
